import { Typography } from '@cast/design-system';

export const OptionalTag = () => {
  return (
    <Typography variant="P12M" fontStyle="italic" color="grey.300">
      (optional)
    </Typography>
  );
};
